/* MiaMia · descripción del producto en desplegables con viñetas.
   Las descripciones vienen de Etsy/Amazon: títulos en <strong>, en letras "𝐁𝐎𝐋𝐃"
   de Unicode, en MAYÚSCULAS o en <h3>, casi siempre separados con <br>. Se parte
   en líneas, cada título abre un desplegable y sus líneas cortas pasan a viñetas.
   Lo que va antes del primer título queda visible (con "Read more"). */
(function () {
  var SMALL = /^(a|an|and|the|of|for|to|in|on|with|or|at|by)$/i;
  var LEAD = /^[\s•✔✅☑✓✨❤️❤🖤💡🛡️🎁⭐️⭐►▶➤\-–—*·]+/u;
  function norm(t) { return (t || '').normalize('NFKC').replace(/\s+/g, ' ').trim(); }
  function cleanTitle(t) {
    t = norm(t).replace(/^[^A-Za-z0-9]+/, '').replace(/[:\s]+$/, '');
    if (t === t.toUpperCase()) t = t.toLowerCase().split(' ').map(function (w, i) { return (i && SMALL.test(w)) ? w : w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
    return t.replace(/\bFaq\b/, 'FAQ');
  }
  function isTitle(el) {
    if (/^H[1-6]$/.test(el.tagName)) return true;
    if (/^(UL|OL|TABLE)$/.test(el.tagName)) return false;
    var raw = (el.textContent || '').replace(/\s+/g, ' ').trim(), t = norm(raw);
    if (!t || t.length > 50) return false;
    if (/^[•✔✅☑✓\-–—*·]|^\d+[.)]/.test(t)) return false;
    // "Line 3: ICE: 000-000-0000" es un ejemplo, no un título
    if (/\d{3}/.test(t) || /:\s*\S/.test(t)) return false;
    var letters = t.replace(/[^A-Za-z]/g, '');
    if (letters.length < 3) return false;
    var bold = Array.prototype.map.call(el.querySelectorAll('strong, b'), function (b) { return b.textContent; }).join('').replace(/\s+/g, ' ').trim();
    if (bold && norm(bold) === t) return true;
    if (!/[A-Za-z]/.test(raw)) return true;
    return letters === letters.toUpperCase();
  }
  function splitLines(desc) {
    var out = [];
    Array.prototype.forEach.call(desc.childNodes, function (node) {
      if (node.nodeType === 3) { if (node.textContent.trim()) { var p0 = document.createElement('p'); p0.textContent = node.textContent; out.push(p0); } return; }
      if (node.nodeType !== 1) return;
      if (/^(UL|OL)$/.test(node.tagName)) { Array.prototype.forEach.call(node.children, function (li) { var p = document.createElement('p'); p.innerHTML = li.innerHTML; out.push(p); }); return; }
      if (/^(H[1-6]|TABLE|IMG|IFRAME|VIDEO)$/.test(node.tagName) || !node.querySelector('br')) { out.push(node.cloneNode(true)); return; }
      var cur = document.createElement('p');
      Array.prototype.forEach.call(node.childNodes, function (c) {
        if (c.nodeName === 'BR') { if (cur.textContent.trim()) out.push(cur); cur = document.createElement('p'); }
        else cur.appendChild(c.cloneNode(true));
      });
      if (cur.textContent.trim()) out.push(cur);
    });
    return out.filter(function (el) { return el.tagName === 'IMG' || (el.textContent || '').trim() || el.querySelector('img'); });
  }
  // Líneas de un desplegable → viñetas (quita emoji/guiones del inicio). Párrafos largos quedan como texto.
  function bodyNodes(lines) {
    var out = [], ul = null;
    lines.forEach(function (el) {
      var txt = norm(el.textContent);
      if (el.tagName === 'P' && txt.length <= 260) {
        if (!ul) { ul = document.createElement('ul'); ul.className = 'mm-desc__list'; out.push(ul); }
        var li = document.createElement('li'); li.innerHTML = el.innerHTML;
        var first = li.firstChild;
        while (first && first.nodeType === 1 && !first.textContent.trim()) { li.removeChild(first); first = li.firstChild; }
        if (first && first.nodeType === 3) first.textContent = first.textContent.replace(LEAD, '');
        else if (first && first.nodeType === 1 && first.firstChild && first.firstChild.nodeType === 3) first.firstChild.textContent = first.firstChild.textContent.replace(LEAD, '');
        if (li.textContent.trim()) ul.appendChild(li);
      } else { ul = null; out.push(el); }
    });
    return out;
  }
  function initDescription(desc) {
    if (desc.dataset.mmDone) return;
    desc.dataset.mmDone = '1';
    var tpl = desc.querySelector('template[data-mm-desc]');
    if (tpl) { desc.innerHTML = ''; desc.appendChild(tpl.content.cloneNode(true)); }
    var lines = splitLines(desc);
    var intro = [], groups = [], g = null;
    lines.forEach(function (el) {
      if (isTitle(el)) { g = { el: el, title: cleanTitle(el.textContent), body: [] }; groups.push(g); }
      else if (g) g.body.push(el);
      else intro.push(el);
    });
    if (!intro.length && groups.length && groups[0].el === lines[0]) { var first = groups.shift(); intro = [first.el].concat(first.body); }
    // "How to order" sobra: el personalizador ya guía la compra (igual que en famgraving)
    groups = groups.filter(function (x) { return x.body.length && !/^how to order\??$/i.test(x.title); });
    if (!groups.length && norm(desc.textContent).length < 320) return;
    var caret = document.querySelector('.product__accordion summary .icon-caret');
    var frag = document.createDocumentFragment();
    var introBox = document.createElement('div');
    introBox.className = 'mm-desc__intro';
    (groups.length ? intro : lines).forEach(function (el) { introBox.appendChild(el); });
    if (introBox.childNodes.length) {
      frag.appendChild(introBox);
      if (norm(introBox.textContent).length > 260) {
        introBox.classList.add('is-clamped');
        var more = document.createElement('button');
        more.type = 'button'; more.className = 'mm-desc__more'; more.textContent = 'Read more';
        more.addEventListener('click', function () { var c = introBox.classList.toggle('is-clamped'); more.textContent = c ? 'Read more' : 'Read less'; });
        frag.appendChild(more);
      }
    }
    groups.forEach(function (x) {
      var wrap = document.createElement('div'); wrap.className = 'product__accordion accordion mm-desc__acc';
      var det = document.createElement('details'); var sum = document.createElement('summary');
      sum.innerHTML = '<div class="summary__title"><h2 class="h4 accordion__title"></h2></div>';
      sum.querySelector('h2').textContent = x.title;
      if (caret) sum.appendChild(caret.cloneNode(true));
      var body = document.createElement('div'); body.className = 'accordion__content rte';
      bodyNodes(x.body).forEach(function (el) { body.appendChild(el); });
      det.appendChild(sum); det.appendChild(body); wrap.appendChild(det); frag.appendChild(wrap);
    });
    desc.innerHTML = ''; desc.appendChild(frag); desc.classList.add('mm-desc');
  }
  function run() { document.querySelectorAll('.mm-description').forEach(initDescription); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* MiaMia · reseñas de Klaviyo (26-oct-2026): en productos sin reseñas el widget
   mostraba un bloque vacío "0 / 5". Si no hay reseñas, se esconde la sección.
   El idioma del widget lo pone Klaviyo según el navegador de quien visita. */
(function () {
  var tries = 0;
  function check() {
    var w = document.getElementById('klaviyo-product-reviews-wrapper');
    if (!w) { if (++tries < 40) setTimeout(check, 500); return; }
    var avg = w.querySelector('.kl_reviews__summary__average_value');
    if (!avg) { if (++tries < 40) setTimeout(check, 500); return; }
    var empty = parseFloat(avg.textContent) === 0 && !w.querySelector('.kl_reviews__review_item');
    if (empty) { var s = w.closest('.shopify-section'); if (s) s.style.display = 'none'; }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
